import classnames from 'classnames';
import { kebabCase } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
const EmployeesRow = props => {
  const index = props.index,
    data = props.data,
    id = props.id,
    _props$data = props.data,
    firstName = _props$data.firstName,
    lastName = _props$data.lastName,
    username = _props$data.username,
    propsOnClick = props.onClick;
  const classes = classnames("t-er-".concat(index), "t-er-last-first-".concat(kebabCase(data.lastName), "-").concat(kebabCase(data.firstName)));
  return /*#__PURE__*/React.createElement("tr", {
    className: classes,
    onClick: () => propsOnClick(id)
  }, /*#__PURE__*/React.createElement("td", {
    className: "t-er-name"
  }, "".concat(lastName, ", ").concat(firstName)), /*#__PURE__*/React.createElement("td", {
    className: "t-er-username t-er-username-".concat(kebabCase(username))
  }, username));
};
EmployeesRow.propTypes = {
  index: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    lastName: PropTypes.string,
    firstName: PropTypes.string,
    username: PropTypes.string
  }).isRequired,
  onClick: PropTypes.func.isRequired
};
export default EmployeesRow;